import React from 'react';

const ResponsiveError = () => {
    return (
        <section className="overview section" id="overview" aria-label="overview">
            <div className="container" style={{ marginTop: "30px" }}>
                <div id="notfound">
                    <div class="notfound">
                        <div class="notfound-404">
                            <h1>Oops!</h1>
                        </div>
                        <h2>431 - Too Small</h2>
                        <p>Your screen width is too small to view this site properly.</p>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ResponsiveError;